/** Screening + Interview endpoints. */
import client from './client';

export const screeningAPI = {
  getMyScreenings: async () => (await client.get('/screening/my-sessions')).data,
  getSession: async (id) => (await client.get(`/screening/${id}`)).data,
  startSession: async (id) => (await client.post(`/screening/${id}/start`)).data,
  submitAnswer: async (id, idx, text) => (await client.post(`/screening/${id}/answer`, { question_index: idx, answer_text: text })).data,
  completeSession: async (id) => (await client.post(`/screening/${id}/complete`)).data,
  scheduleScreening: async (matchId) => (await client.post(`/screening/schedule/${matchId}`)).data,
  getRecruiterSessions: async () => (await client.get('/screening/recruiter/sessions')).data,
};

export const interviewAPI = {
  create: async (jobId, candidateId) => (await client.post('/interviews/create', { job_id: jobId, candidate_id: candidateId })).data,
  get: async (id) => (await client.get(`/interviews/${id}`)).data,
  submitAnswer: async (id, questionIndex, questionText, answerText, audioUrl = '', duration = 0) =>
    (await client.post(`/interviews/${id}/answer`, { question_index: questionIndex, question_text: questionText, answer_text: answerText, audio_url: audioUrl, duration })).data,
  complete: async (id) => (await client.post(`/interviews/${id}/complete`)).data,
};

export default screeningAPI;
